<template>
    <div id="app">

        <Header></Header>

        <main>

            <TitleScreen></TitleScreen>

            <WhoIsThisFor></WhoIsThisFor>

            <MarketAnalysis></MarketAnalysis>

            <DescriptionScreens></DescriptionScreens>

            <ProductRoadmap></ProductRoadmap>

            <BetaAccess :subscribe-type="subscribeType"
            >
            </BetaAccess>

            <Plans @subscribe="onSubscribe"
            >
            </Plans>

            <Investors></Investors>

            <News></News>

            <Footer></Footer>

        </main>

    </div>
</template>

<script>
    import TitleScreen from "./components/TitleScreen"
    import Header from "./components/Header"
    import WhoIsThisFor from "./components/WhoIsThisFor"
    import MarketAnalysis from "./components/MarketAnalysis"
    import DescriptionScreens from "./components/DescriptionScreens"
    import ProductRoadmap from "./components/ProductRoadmap"
    import BetaAccess from "./components/BetaAccess"
    import Plans from "./components/Plans"
    import Investors from "./components/Investors"
    import News from "./components/News"
    import Footer from "./components/Footer"

    export default {
        name: 'App',
        components: {
            TitleScreen,
            Header,
            WhoIsThisFor,
            MarketAnalysis,
            DescriptionScreens,
            ProductRoadmap,
            BetaAccess,
            Plans,
            Investors,
            News,
            Footer
        },
        data() {
            return {
                subscribeType: null
            }
        },
        methods: {
            onSubscribe(index) {

                this.subscribeType = index

            }
        },
        mounted() {

            this.$parallax.init()

        }
    }
</script>